import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconStage"><Path d="M2.5 4.5H21.5V19.5H2.5V4.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M21.2496 18.7498L17.9998 15.5H5.9998L2.75 18.7498" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconStage;
